/**
 * Canonical spawn placement, shared by server and client. The server writes
 * these into a joining player's state (MallRoom.onJoin) and the client
 * teleports the local camera to the same spot while loading (main.ts). The
 * two MUST agree: when they diverged, freshly-joined avatars sat at the
 * world origin inside the atrium centerpiece planter, invisible to everyone,
 * for the joiner's whole loading screen.
 *
 * Spawn is just behind the atrium's north bench, between it and the
 * escalator landings, facing north.
 */
export const SPAWN_POSE = { x: 0, y: 0, z: 11, yaw: 0 };
/** Golden angle: consecutive joiners land far apart on the scatter ring. */
const SCATTER_ANGLE_RAD = 2.399963229728653;
const SCATTER_RADIUS_M = 1.5;
/**
 * Spawn pose for the index-th joiner a room has seen. The first joiner gets
 * the exact spawn point; everyone after lands on a 1.5 m ring around it so
 * players loading in together never stand inside each other (or inside each
 * other's cameras, which reads as invisible).
 */
export function spawnPoint(index) {
    if (index <= 0) {
        return { ...SPAWN_POSE };
    }
    const angle = index * SCATTER_ANGLE_RAD;
    return {
        x: SPAWN_POSE.x + Math.cos(angle) * SCATTER_RADIUS_M,
        y: SPAWN_POSE.y,
        z: SPAWN_POSE.z + Math.sin(angle) * SCATTER_RADIUS_M,
        yaw: SPAWN_POSE.yaw,
    };
}
//# sourceMappingURL=spawn.js.map